<section class="flex flex-col mb-5 md:gap-4">
  <div class="flex items-center gap-4">
    <span class="text-3xl text-[#0045E6] font-semibold"
      >{{ type }} {{ type === "NEWS" ? "RECOMMANDÉES" : "RECOMMANDÉS" }}
    </span>
    <div class="flex-1 border-t-4 border-gray-200"></div>
  </div>
  <div
    class="grid w-full grid-cols-1 md:grid-cols-2 md:grid-rows-3 md:grid-flow-col"
  >
    <div
      *ngFor="let media of listeMedias; index as i"
      class="border-[#C1C1C1] py-5 border-b last:border-b-0 md:px-5 md:[&:nth-child(-n+3)]:border-r md:[&:nth-child(3)]:border-b-0"
    >
      <a
        [routerLink]="[
          '/actualites',
          type === 'NEWS' ? 'news' : 'articles',
          media.nom | convertToSlug,
          media.id,
        ]"
        class="flex w-full items-start gap-6"
      >
        <span class="hidden text-[#0045E6] text-6xl font-bold font md:inline">{{
          i + 1
        }}</span>
        <span class="line-clamp-4 flex-1">
          <span class="font-semibold sm:text-lg">{{ media.nom }}</span
          ><br />
          {{ media?.contenu | extractTextFromHtml }}
        </span>
        <app-image
          [imageClass]="'w-26 h-26 rounded-lg object-cover sm:w-44'"
          [imageSrc]="cloud_front + media?.image"
          [showIfNotLoaded]="true"
        />
      </a>
    </div>
  </div>
</section>
